// extracted by mini-css-extract-plugin
export default {"icon":"_8yNdJcxdk0","left":"S1kNzZyISW","right":"_0GvQJvhC3E"};
    if(module.hot) {
      // 1643570390037
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  